import axios from 'axios';
import API_CONFIG from '../config/api';
import { getAuthHeaders } from '../utils/auth';

const uploadService = {
  // Upload single image
  uploadImage: async (file, type = 'blog') => {
    try {
      const formData = new FormData();
      // Always use 'image' field as expected by backend route upload.single('image')
      formData.append('image', file);

      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/upload/image`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error('Upload error:', error);
      throw error.response?.data || { message: 'Upload failed' };
    }
  },

  // Upload multiple images
  uploadMultipleImages: async (files) => {
    try {
      const formData = new FormData();

      files.forEach((file) => {
        formData.append('images', file);
      });

      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/upload/images`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error('Upload error:', error);
      throw error.response?.data || { message: 'Upload failed' };
    }
  },

  // Generic upload with progress
  uploadWithProgress: async (file, type = 'blog', onProgress) => {
    try {
      const formData = new FormData();
      // Always use 'image' field
      formData.append('image', file);

      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/upload/image`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            if (onProgress) {
              onProgress(percentCompleted);
            }
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error('Upload error:', error);
      throw error.response?.data || { message: 'Upload failed' };
    }
  },
};

export default uploadService;

